/* eslint-disable camelcase */
import { getRatingToString } from "mixins/helperCandidate";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import "./styles.scss";
import { TFunction, withTranslation } from "react-i18next";

const InterviewHeaderScorecard = ({
  t,
  score,
  total,
  fontSize = 14,
  fontColor = null,
  buttonHeight = undefined,
  iconOnly = false,
  customStyles = {}
}: {
  t: TFunction;
  score: number;
  total: number;
  fontSize: number;
  fontColor: string | null;
  iconHeight: string | number | undefined;
  iconWidth: string | undefined;
  buttonHeight: number | undefined;
  iconOnly: boolean;
  customStyles: React.CSSProperties;
}) => {
  const rating = getRatingToString({
    t,
    rating: score,
    isActive: true
  });

  const bgColor = useMemo(() => {
    switch (score) {
    case 1:
      return "bg-tertiary-red-10";
    case 2:
      return "bg-tertiary-red-10";
    case 3:
      return "bg-tertiary-orange-10";
    case 4:
      return "bg-tertiary-green-10";
    case 5:
      return "bg-tertiary-green-10";
    default:
      return "bg-tertiary-green-10";
    }
  }, [score]);

  const numberBgColor = useMemo(() => {
    switch (score) {
    case 1:
      return "bg-tertiary-red";
    case 2:
      return "bg-tertiary-red";
    case 3:
      return "bg-tertiary-orange";
    case 4:
      return "bg-tertiary-green";
    case 5:
      return "bg-tertiary-green";
    default:
      return "bg-tertiary-green";
    }
  }, [score]);

  return (
    <div
      className={`overview-rating__icon ${bgColor} px-2 py-1`}
      style={{
        color: fontColor ?? rating?.color,
        ...customStyles,
        ...(buttonHeight ? { minHeight: "28px" } : {}),
        borderRadius: 8
      }}
    >
      <div style={{ fontSize }}>
        {`${!iconOnly && rating?.label ? rating?.label : ""}`}
      </div>
      <div style={{ fontSize, color: "white", lineHeight: "18px" }} className={`px-2 rounded-lg ${numberBgColor}`}>
        {total ? `${total}` : ""}
      </div>
    </div>
  );
};

InterviewHeaderScorecard.defaultProps = {
  total: 0,
  fontSize: 12,
  fontColor: null,
  score: 0,
  buttonHeight: undefined,
  iconOnly: false,
  customStyles: {}
};

InterviewHeaderScorecard.propTypes = {
  t: PropTypes.func.isRequired,
  buttonHeight: PropTypes.number,
  fontColor: PropTypes.string,
  fontSize: PropTypes.number,
  iconOnly: PropTypes.bool,
  score: PropTypes.number,
  total: PropTypes.number,
  customStyles: PropTypes.shape({})
};

export default withTranslation()(InterviewHeaderScorecard);
